export interface UmpireExternalProviderPointer {
  external_id: string;
  provider: string;
}

export interface ProviderSyncData {
  type: ProviderTypeEnum;
  attributes: ProviderAttributes;
  relationships: {
    [key: string]: any;
  };
}

export interface ProviderAttributes {
  resource: string;
  provider: string;
  force_update: boolean;
}

export enum ProviderTypeEnum {
  external_data_provider = 'external_data_provider',
}

export enum ProviderType {
  opta = 'opta',
  chyron = 'chyron',
}
